import { defineQuiz } from "./_schema";
import { igniteQuiz } from "./ignite";

/**
 * QUIZ-V6-GATED -- a faithful clone of the live Ignite quiz (quiz-v6) with an
 * email-capture gate embedded in the `applying` loader (Variant C, hard gate).
 *
 * Everything that routes users -- `questions`, `branching`, `classifier`,
 * `deriveProfile`, `meta`, `capture` -- is reused verbatim from `igniteQuiz`
 * (same object references), so this clone is regression-identical to ignite:
 * the persona distribution, deriveProfile histogram, and suppression floor are
 * all the same walks. The ONLY differences are:
 *   - `id` / `slug`         : distinct surface ("quiz-v6-gated")
 *   - `emailGate: true`     : turns on the in-loader email gate (see
 *                             PersonaQuiz.emailGate in _schema.ts). The gate is
 *                             hard -- email is required to reach the PDP; there
 *                             is no skip. Submission is deferred to the gate so
 *                             the captured email lands on the Klaviyo row.
 *   - `experiment: undefined`: this clone is NOT enrolled in ignite's
 *                             Intelligems test. A quiz without `experiment`
 *                             never touches window.igData (rule #24); if growth
 *                             later wants a gated-vs-ungated split, add an
 *                             `experiment` block here with its own test id.
 *
 * Do NOT edit routing/copy here -- edit `ignite.ts` (this clone inherits it) or
 * fork the shared references if the two surfaces need to diverge. `ignite`
 * itself is untouched and stays the regression-locked live surface.
 */
export const quizV6GatedQuiz = defineQuiz({
  ...igniteQuiz,
  id: "quiz-v6-gated",
  slug: "quiz-v6-gated",
  emailGate: true,
  experiment: undefined,
});
